// expo export/start --platform web statically renders routes in Node.js, where
// requestAnimationFrame does not exist. react-native-worklets schedules
// flushUIQueue with it unconditionally, so install a setTimeout fallback before
// any library module initializes. On native this is a no-op because Hermes
// already provides the global.
interface AnimationFrameGlobal {
  requestAnimationFrame?: (callback: (timestamp: number) => void) => number;
  cancelAnimationFrame?: (handle: number) => void;
}

const animationFrameGlobal = globalThis as AnimationFrameGlobal;

if (typeof animationFrameGlobal.requestAnimationFrame === 'undefined') {
  animationFrameGlobal.requestAnimationFrame = (callback) =>
    // SAFETY: Node.js setTimeout returns a Timeout object, not a number, but the
    // same opaque value is handed back to clearTimeout via cancelAnimationFrame,
    // so the numeric frame-id contract is preserved across the polyfill pair.
    setTimeout(() => callback(Date.now()), 16) as unknown as number;

  animationFrameGlobal.cancelAnimationFrame = (handle) => {
    clearTimeout(handle);
  };
}
